import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

// Auth Services
import { AuthMyfileService } from '../services/auth.myfile.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthMyfileService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUserContext = this.authService.currentUserContextValue;

        if (currentUserContext) {
            return true;
        }

        var redirect: string | undefined = undefined;

        redirect = route.queryParams['redirectAfterLogin'];
        if (redirect === 'true') {
            this.authService.logout(state.url);
        } else {
            this.authService.logout();
        }
        return false;
    }
}
